import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles'
import { Translate } from 'react-localize-redux'

/** Material-UI imports section */
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import Tab from '@material-ui/core/Tab'
import Paper from '@material-ui/core/Paper'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Divider from '@material-ui/core/Divider'
import { AppBar, Tabs } from '@material-ui/core'

import MemosIcon from '@material-ui/icons/FileCopyTwoTone'
import QuotesIcon from '@material-ui/icons/AttachMoneyTwoTone'
import SamplesIcon from '@material-ui/icons/UnarchiveTwoTone'
import RefreshIcon from '@material-ui/icons/Refresh'
import PowerSettingIcon from '@material-ui/icons/PowerSettingsNew'

/** Import component section */
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import LoadingPage from '../common/LoadingPage'
import DataTable from '../common/DataTable'
import AddCommonItem from '../common/AddCommonItem'
import CostSummary from '../materialDelivery/components/CostSummary'

import {
    loadRequirementRequestFromBackEnd,
    updateDataRequirementRequestFromBackend,
    finalizeRequirementRequestFromBackend,
} from '../../store/requirementRequest/RequirementRequestAction'
import { IsCurrentActiveDirectoryUser } from '../../store/helpers/SessionHelper'
import { canBeValidateModuleDevelopment } from '../../store/helpers/RolesHelper'
import { converListToArray } from '../../store/helpers/ListHelper'

class Show extends Component {
    constructor(props) {
        super(props)
        autoBind(this)
        this.state = {
            openUpdateRequirementRequest: false,
            openFinalizeRequirementRequest: false,
            activeTab: 0,
        }
    }

    componentDidMount() {
        this.props.loadRequirementRequest(this.props.match.params.token)
    }

    onClickToActiveTab(event, value) {
        this.setState({ activeTab: value })
    }

    onUpdateRequirementRequest() {
        this.setState({ openUpdateRequirementRequest: true })
    }

    onFinalizeRequirementRequest() {
        this.setState({ openFinalizeRequirementRequest: true })
    }

    onUpdateFromBackend() {
        const { requirementRequest, selectedCompany } = this.props
        this.props.updateDataRequirementRequest(requirementRequest.folio, selectedCompany.token)
            .then(() => { this.setState({ openUpdateRequirementRequest: false }) })
            .catch(() => { this.setState({ openUpdateRequirementRequest: false }) })
    }

    onFinalizeFromBackend() {
        this.props.finalizeRequirementRequest(this.props.match.params.token)
            .then(() => { this.setState({ openFinalizeRequirementRequest: false }) })
            .catch(() => { this.setState({ openFinalizeRequirementRequest: false }) })
    }

    getCardContent() {
        if (this.props.isLoadingRequirementRequest === true) {
            return <LoadingPage />
        }
        if (!this.props.requirementRequest) return null

        const { classes } = this.props
        return (
            <Grid container spacing={24}>
                <Grid item xs={12}>
                    <InformationCard requirementRequest={this.props.requirementRequest} />
                    <AppBar position='static' color='default'>
                        <Tabs
                            indicatorColor='secondary'
                            textColor='secondary'
                            className={classes.styleTab}
                            value={this.state.activeTab}
                            onChange={this.onClickToActiveTab}
                        >
                            <Tab label={<Translate id='common.supplier' />} />
                            <Tab label={<Translate id='common.costSummary' />} />
                        </Tabs>
                    </AppBar>
                    {this.state.activeTab === 0 && (
                        <Grid item xs={12}>
                            <Divider />
                            <SuppliersCard {...this.props} />
                        </Grid>
                    )}
                    {this.state.activeTab === 1 && (
                        <Grid item xs={12}>
                            <Divider />
                            <CostSummary materialDelivery={this.props.requirementRequest} {...this.props} />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        )
    }

    render() {
        const { classes, requirementRequest, isSaving } = this.props
        const folio = requirementRequest ? requirementRequest.folio : ''
        const canFinalize =
            requirementRequest &&
            !requirementRequest.is_closed &&
            !requirementRequest.status_is_closed &&
            canBeValidateModuleDevelopment(this.props.userRolesByCompany)

        return (
            <Card>
                <CardHeader
                    avatar={
                        <Avatar>
                            <MemosIcon />
                        </Avatar>
                    }
                    action={
                        <div className={classes.actionsToolbar}>
                            {canFinalize && (
                                <span>
                                    <Tooltip title={<Translate id='requirementRequest.updateTitle' />}>
                                        <IconButton color='primary' onClick={this.onUpdateRequirementRequest}>
                                            <RefreshIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={<Translate id='requirementRequest.finalizeTitle' />}>
                                        <IconButton color='primary' onClick={this.onFinalizeRequirementRequest}>
                                            <PowerSettingIcon />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            )}
                        </div>
                    }
                    title={
                        <Typography variant='button'>
                            <Translate id='menu.requirementRequest' />: <strong>{folio}</strong>
                        </Typography>
                    }
                />
                <CardContent>{this.getCardContent()}</CardContent>

                {this.state.openUpdateRequirementRequest && (
                    <AddCommonItem
                        title={<Translate id='requirementRequest.updateTitle' />}
                        message={<Translate id='requirementRequest.updateMessage' />}
                        open={this.state.openUpdateRequirementRequest}
                        onClose={() => this.setState({ openUpdateRequirementRequest: false })}
                        onSaveItem={this.onUpdateFromBackend}
                        isSaving={isSaving}
                        isMessage={true}
                    />
                )}

                {this.state.openFinalizeRequirementRequest && (
                    <AddCommonItem
                        title={<Translate id='requirementRequest.finalizeTitle' />}
                        message={<Translate id='requirementRequest.finalizeMessage' />}
                        open={this.state.openFinalizeRequirementRequest}
                        onClose={() => this.setState({ openFinalizeRequirementRequest: false })}
                        onSaveItem={this.onFinalizeFromBackend}
                        isSaving={isSaving}
                        isMessage={true}
                    />
                )}
            </Card>
        )
    }
}

class InformationCard extends Component {
    render() {
        const { requirementRequest } = this.props
        return (
            <Paper>
                <List>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={<Typography variant='subtitle1' gutterBottom><Translate id='requirementRequest.folioInput' />:</Typography>} />
                        <ListItemSecondaryAction>
                            <Typography variant='subtitle2' color='textSecondary' gutterBottom>{requirementRequest.folio}</Typography>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={<Typography variant='subtitle1' gutterBottom><Translate id='memos.project' />:</Typography>} />
                        <ListItemSecondaryAction>
                            <Typography variant='subtitle2' color='textSecondary' gutterBottom>{requirementRequest.project_name}</Typography>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={<Typography variant='subtitle1' gutterBottom>{'Volumen '}:</Typography>} />
                        <ListItemSecondaryAction>
                            <Typography variant='subtitle2' color='textSecondary' gutterBottom>{requirementRequest.project_volume}</Typography>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={<Typography variant='subtitle1' gutterBottom><Translate id='memos.stage' />:</Typography>} />
                        <ListItemSecondaryAction>
                            <Typography variant='subtitle2' color='textSecondary' gutterBottom>{requirementRequest.stage}</Typography>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={<Typography variant='subtitle1' gutterBottom><Translate id='materialDelivery.deliveryDate' />:</Typography>} />
                        <ListItemSecondaryAction>
                            <Typography variant='subtitle2' color='textSecondary' gutterBottom>{requirementRequest.mem_com_date}</Typography>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={<Typography variant='subtitle1' gutterBottom><Translate id='common.comments' />:</Typography>} />
                        <ListItemSecondaryAction>
                            <Typography variant='subtitle2' color='textSecondary' gutterBottom>{requirementRequest.developer_comments}</Typography>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary={<Typography variant='subtitle1' gutterBottom><Translate id='common.status' />:</Typography>} />
                        <ListItemSecondaryAction>
                            <Typography variant='subtitle2' color='textSecondary' gutterBottom>{requirementRequest.status_description}</Typography>
                        </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                </List>
            </Paper>
        )
    }
}

class SuppliersCard extends Component {
    onRenderCellItem(dataSource, item) {
        if (dataSource === 'folio') {
            if (item.type_request === 'QuoteSamples') return <div><QuotesIcon color='primary' /> {item.folio}</div>
            if (item.type_request === 'SampleRequest') return <div><SamplesIcon color='secondary' /> {item.folio}</div>
        }
        if (dataSource === 'type_request') {
            if (item.type_request === 'QuoteSamples') return <Translate id='quotes.quote' />
            if (item.type_request === 'SampleRequest') return <Translate id='samplesrequest.samplesrequest' />
        }
    }

    getFilteredSuppliersList(data) {
        return (data.suppliers || []).filter(
            (supplier) => supplier.supplier_token === this.props.user.profile.company_token
        )
    }

    getSuppliersList() {
        const { requirementRequest } = this.props
        if (!requirementRequest) return <LoadingPage />

        const suppliers = IsCurrentActiveDirectoryUser(this.props.user)
            ? requirementRequest.suppliers
            : this.getFilteredSuppliersList(requirementRequest)

        return (suppliers || []).map((supplier) => (
            <DataTable
                key={supplier.supplier_token}
                title={
                    <Typography variant='subtitle2' gutterBottom>
                        <strong>{supplier.supplier_code} | {supplier.supplier_name.toUpperCase()}</strong>
                    </Typography>
                }
                data={supplier.quotes}
                configuration={TableQuotesConfiguration}
                onRenderCellItem={this.onRenderCellItem}
                onRowClick={(item) => {
                    if (item.type_request === 'QuoteSamples') this.props.history.push(`/quotes/${item.token}`)
                    else if (item.type_request === 'SampleRequest') this.props.history.push(`/samplerequests/${item.token}`)
                }}
            />
        ))
    }

    render() {
        return <Paper>{this.getSuppliersList()}</Paper>
    }
}

const TableQuotesConfiguration = {
    columns: [
        { header: <Translate id='common.folio' />, dataSource: 'folio' },
        { header: <Translate id='memos.documentType' />, dataSource: 'type_request' },
        { header: <Translate id='common.status' />, dataSource: 'status' },
    ],
}

function mapStateToProps(state) {
    let user = state.oidc.user ? state.oidc.user : { profile: { name: '', email: '', user_type: '' } }
    let selectedCompany = state.profile.get('selectedCompany')
    let requirementRequest = state.requirementRequest.get('requirementRequest')
    let userRolesByCompany = state.profile.get('userRolesByCompany')
    return {
        user,
        selectedCompany: selectedCompany ? selectedCompany.toJS() : null,
        isLoadingRequirementRequest: state.requirementRequest.get('isLoadingRequirementRequest'),
        requirementRequest: requirementRequest ? requirementRequest.toJS() : null,
        isSaving: state.requirementRequest.get('isSaving'),
        userRolesByCompany: userRolesByCompany ? converListToArray(userRolesByCompany) : [],
    }
}

const mapDispatchToProps = (dispatch) => ({
    loadRequirementRequest: (token) => dispatch(loadRequirementRequestFromBackEnd(token)),
    updateDataRequirementRequest: (folio, companyToken) =>
        dispatch(updateDataRequirementRequestFromBackend(folio, companyToken)),
    finalizeRequirementRequest: (token) => dispatch(finalizeRequirementRequestFromBackend(token)),
})

const styles = (theme) => ({
    actionsToolbar: {
        display: 'flex',
    },
    styleTab: {
        backgroundColor: '#fff',
    },
})

export default withauthenticatedLayout(
    withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Show)))
)
